import { createSecretKey } from "@core/foundation/token";
import type { z } from "@core/zod";

import { KEY_PREFIX } from "./key-prefix.ts";

export const {
  generateKey: generateOAuthAuthorizationKey,
  keySchema: OAuthAuthorizationKeySchema,
  verifyKey: verifyOAuthAuthorizationKey,
} = createSecretKey({ keyPrefix: KEY_PREFIX.OAUTH_AUTHORIZATION });

export type OAuthAuthorizationKey = z.infer<typeof OAuthAuthorizationKeySchema>;
